import { c as _c } from "react/compiler-runtime";
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import cn from 'classnames';
import style from './ButtonTooltip.module.scss';
const ButtonTooltip = t0 => {
  const $ = _c(5);
  const {
    text,
    className,
    textSvg,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== text || $[3] !== textSvg) {
    t1 = <>{!textSvg ? <div className={cn(style.container, className)}>{text ? text : children}</div> : <SafeHtmlRenderer tag="div" className={cn(style.container, className)} content={textSvg || ""} />}</>;
    $[0] = children;
    $[1] = className;
    $[2] = text;
    $[3] = textSvg;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default ButtonTooltip;